import { LoanLandingScreen } from "@/screens/loans/LoanLandingScreen"

export default function LoansLandingPage() {
  return <LoanLandingScreen />
}
